const parseFeatureFlag = (value, fallback = true) => {
	if (value === undefined || value === null || value === "") {
		return fallback;
	}
	if (typeof value === "boolean") {
		return value;
	}
	const normalized = String(value).replace(/^["']|["']$/g, "").trim().toLowerCase();
	if (["true", "1", "yes", "on"].includes(normalized)) {
		return true;
	}
	if (["false", "0", "no", "off"].includes(normalized)) {
		return false;
	}
	return fallback;
};

export const workflowAddonAvailability = Object.freeze({
	paymentQr: parseFeatureFlag(process.env.WORKFLOW_PAYMENT_QR_ENABLED, true),
	digitalSignature: parseFeatureFlag(process.env.WORKFLOW_DIGITAL_SIGNATURE_ENABLED, true),
});
